import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import { purchaseOrdersCreate } from '../../redux/actions/purchaseOrders';
import { reset } from '../../redux/actions/purchaseOrderLines';
import { suppliersIndex } from '../../redux/actions/suppliers';
import { taxSettingsIndex } from '../../redux/actions/taxSettings';
import { paymentTermsIndex } from '../../redux/actions/paymentTerms';
import { paymentMethodsIndex } from '../../redux/actions/paymentMethods';
import { locationsIndex } from '../../redux/actions/locations';

import AssignmentList from './AssignmentList';
import ProductSearch from './ProductSearch';
import ProductScan from './ProductScan';
import PurchaseOrderLine from './PurchaseOrderLine';
import PurchaseOrderTotals from './PurchaseOrderTotals';

import AddExternalItemModal from './AddExternalItemModal';
import UpdateExternalItemModal from './UpdateExternalItemModal';


const NewPurchaseOrderForm = ({ 
  payload,
  shippingOrigin,
  purchaseOrders,
  newPurchaseOrder,
  taxSettings,
  paymentTerms,
  paymentMethods,
  suppliers,
  loadTaxSettings,
  loadPaymentTerms,
  loadPaymentMethods,
  loadSuppliers,
  locations,
  loadLocations,
  addPurchaseOrder,
  purchaseOrderLines,
  clearPOLines,
  settings
}) => {
  let navigate = useNavigate();

  const [activeSupplier, setActiveSupplier] = useState(null);
  const [activeShippingAddress, setActiveShippingAddress] = useState(null);
  const [activePaymentTerm, setActivePaymentTerm] = useState(null);
  const [activePaymentMethod, setActivePaymentMethod] = useState(null);
  const [activeTaxSetting, setActiveTaxSetting] = useState(null);

  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [supplierOrderNumber, setSupplierOrderNumber] = useState(null);
  const [notes, setNotes] = useState(null);

  const [activeTab, setActiveTab] = useState('list');

  const [adjustedTotal, setAdjustedTotal] = useState(null);
  const [shippingTotal, setShippingTotal] = useState(null);
  const [expectedDate, setExpectedDate] = useState(null);
  const [paymentDate, setPaymentDate] = useState(null);

  const [submitted, setSubmitted] = useState(false);

  const [showAddExternalItemModal, setShowAddExternalItemModal] = useState(false);

  const [showUpdateExternalItemModal, setShowUpdateExternalItemModal] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [updateName, setUpdateName] = useState(null);
  const [updatePrice, setUpdatePrice] = useState(null);
  const [updateSku, setUpdateSku] = useState(null);

  const [warnings, setWarnings] = useState({ moq: {}, orderMultiple: {} });
  const [modalY, setModalY] = useState(0);

  useEffect(() => {
    clearPOLines();

    loadTaxSettings(payload);
    loadPaymentTerms(payload);
    loadPaymentMethods(payload);
    loadSuppliers(payload);
    loadLocations(payload);
  }, []);

  useEffect(() => {
    if(newPurchaseOrder) { navigate(-1) };
  }, [newPurchaseOrder]);

  useEffect(() => {
    let newWarnings = { moq: {}, orderMultiple: {} };

    // purchaseOrderLines.lineItems.forEach(lineItem => {
    //   let itemKey = lineItem.productId + '/' + lineItem.variantId;

    //   if(parseInt(lineItem.minimumOrder) > purchaseOrderLines.lineDetails[itemKey].quantity) {
    //     newWarnings.moq[itemKey] = `${lineItem.name || lineItem.productName} line quantity below MOQ: ${lineItem.minimumOrder} vs. ${purchaseOrderLines.lineDetails[itemKey].quantity}`
    //   }

    //   if(settings?.settings?.order_multiples) {
    //     if(lineItem.orderMultiple && ((purchaseOrderLines.lineDetails[itemKey].quantity % lineItem.orderMultiple) !== 0)) {
    //       newWarnings.orderMultiple[lineItem.productId + '/' + lineItem.variantId] = `${lineItem.name || lineItem.productName} line not divisible by assignment order multiple: ${lineItem.orderMultiple}`
    //     }
    //   }
    // });

    purchaseOrderLines.lineItems.forEach(lineItem => {
      let itemKey = lineItem.productId + '/' + lineItem.variationId;

      if(parseInt(lineItem.minimumOrder) > purchaseOrderLines.lineDetails[itemKey].quantity) {
        newWarnings.moq[itemKey] = `${lineItem.name || lineItem.productName} line quantity below MOQ: ${lineItem.minimumOrder} vs. ${purchaseOrderLines.lineDetails[itemKey].quantity}`
      }

      if(settings?.settings?.order_multiples) {
        if(lineItem.orderMultiple && ((purchaseOrderLines.lineDetails[itemKey].quantity % lineItem.orderMultiple) !== 0)) {
          newWarnings.orderMultiple[lineItem.productId + '/' + lineItem.variationId] = `${lineItem.name || lineItem.productName} line not divisible by assignment order multiple: ${lineItem.orderMultiple}`
        }
      }
    });

    setWarnings(newWarnings);
  }, [purchaseOrderLines]);

  const purchaseOrderJson = () => {
    // TODO: adjust all dates to more standard dates, or modify backend

    return {
      supplier: activeSupplier,
      shipping_address: activeShippingAddress,
      payment_term: activePaymentTerm,
      payment_method: activePaymentMethod,
      tax_setting: activeTaxSetting,
      invoice_number: invoiceNumber,
      supplier_order_number: supplierOrderNumber,
      notes: notes,
      invoice_date: invoiceDate,
      adjusted_total: adjustedTotal,
      shipping_total: shippingTotal || 0.0,
      expected_date: expectedDate,
      payment_due_date: paymentDate
    }
  }

  const purchaseOrderLinesJson = () => {
    let orderLines = [];

    purchaseOrderLines?.lineItems?.forEach(purchaseOrderLine => {
      let key = purchaseOrderLine.productId + '/' + purchaseOrderLine.variationId;
      let lineWithDetails = {...purchaseOrderLine};
      lineWithDetails.line_details = purchaseOrderLines.lineDetails[key];
      orderLines.push(lineWithDetails);
    })

    return orderLines;
  }

  const setFieldValue = (setField, event) => {
    let value = event.target.value;
    setField(value);

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
  }

  const setDropdownValue = (setField, value) => {
    setField(value);
  }

  const activateSupplier = (supplierId) => {
    let supplier = suppliers.suppliers.find(sup => sup.id === supplierId);

    setActiveSupplier(supplier);
    setActivePaymentTerm(paymentTerms.paymentTerms.find(term => term.id === supplier.payment_terms_id));
    setActivePaymentMethod(paymentMethods.paymentMethods.find(method => method.id === supplier.payment_method_id));
    setActiveTaxSetting(taxSettings.taxSettings.find(setting => setting.id === supplier.tax_setting_id));

    if(supplier.shipping_days) {
      let expected = new Date();

      expected.setDate(expected.getDate() + parseInt(supplier.shipping_days));

      const yyyy = expected.getFullYear();
      let mm = expected.getMonth() + 1; // months start at 0
      let dd = expected.getDate();

      if (dd < 10) dd = '0' + dd;
      if (mm < 10) mm = '0' + mm;

      // let formattedExpected = yyyy + '-' + mm + '-' + dd + 'T05:00:00.000Z';
      let formattedExpected = yyyy + '-' + mm + '-' + dd;


      setExpectedDate(formattedExpected);
    }
  }

  const setShippingAddress = (locationId) => {
    if(locationId === 'Ecwid Origin') {
      setActiveShippingAddress({
          id: "Ecwid Origin",
          label: 'Store Shipping Origin',
          company: shippingOrigin.companyName,
          first_name: null,
          last_name: null,
          street_1: shippingOrigin.street,
          street_2: null,
          city: shippingOrigin.city,
          state: shippingOrigin.stateOrProvinceCode,
          zip: shippingOrigin.postalCode
        });
      return;
    }

    let location = locations.locations.find(loc => loc.id === locationId);
    
    if(!location) {
      location = locations?.corporateLocations?.locations.find(loc => loc.id === locationId);
    }

    setActiveShippingAddress(location);
  }

  const setPaymentTerm = (paymentTermId) => {
    let paymentTerm = paymentTerms.paymentTerms.find(term => term.id === paymentTermId);
    setActivePaymentTerm(paymentTerm);
  }

  const setPaymentMethod = (paymentMethodId) => {
    let paymentMethod = paymentMethods.paymentMethods.find(method => method.id === paymentMethodId);
    setActivePaymentMethod(paymentMethod);
  }

  const setTaxSetting = (taxSettingId) => {
    let taxSetting = taxSettings.taxSettings.find(tax => tax.id === taxSettingId);
    setActiveTaxSetting(taxSetting);
  }



  const emptyToNull = (value) => {
    console.log(value);

    let emptyOrNull = value;
    
    if(value === '') {
      emptyOrNull = null;
    }

    return emptyOrNull;
  }

  const validPO = () => {
    let block = !(activeShippingAddress && activePaymentTerm && activePaymentMethod && activeTaxSetting && expectedDate && paymentDate && invoiceDate && (purchaseOrderLines?.lineItems.length > 0))

    if(settings?.settings?.warnings_block) {
      if (Object.keys(warnings.moq).length > 0 || Object.keys(warnings.orderMultiple).length > 0) {
        block = true;
      }
    }

    return block;
  }

  const showAddExternal = (event, ) => {
    setModalY(event.pageY);
    setShowAddExternalItemModal(true);
  }

  const showUpdateExternal = (event, id, name, price, sku) => {
    setModalY(event.pageY);
    setUpdateId(id);
    setUpdateName(name);
    setUpdatePrice(price);
    setUpdateSku(sku);
    setShowUpdateExternalItemModal(true);
  }

  const handleSubmit = () => {
    setSubmitted(true);
    addPurchaseOrder(payload, purchaseOrderJson(), purchaseOrderLinesJson());
  }

  const todayForm = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // months start at 0
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    let todayDate = `${yyyy}-${mm}-${dd}`;

    return todayDate;
  }

  const [invoiceDate, setInvoiceDate] = useState(todayForm());


  const nextYear = () => {
    const today = new Date();
    const yyyy = today.getFullYear() + 1;
    let mm = today.getMonth() + 1; // months start at 0
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    // let next = mm + '/' + dd + '/' + yyyy;

    let next = `${yyyy}-${mm}-${dd}`;

    return next;
  }

  return(
    <>
      <PageHeader stripeBackground='#070808' helpLink="ecwid/create-and-update-purchase-orders-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">New Purchase Order</div>
              </div>
              <div className="named-area__description">
                <p>From this page, you can create purchase orders.</p>
                <p>Start by selecting a supplier to send this purchase order to. If the supplier you're looking for is missing, you can add it by going to the <Link to="/suppliers">Suppliers page</Link>.</p>
                <p>
                  Select an address for the order to be sent to from the "Ship To Address" dropdown menu. If the address you're shipping to is missing, you can add it by going to the <Link to="/locations">Addresses page</Link>.
                  If the address selected is your store shipping origin, product inventory levels will be updated when receiving orders. Otherwise, inventory levels will not be modified when receiving this order.
                </p>
                <p>Set payment terms, a payment method and tax settings from their respective dropdowns. If options are missing, you can add them by going to the <Link to="/settings">Settings page</Link>.</p>
                

              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">
                
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { (suppliers.isFetching || paymentTerms.status !== 'success' || paymentMethods.status !== 'success' || taxSettings.status !== 'success') &&
                      <LoadingSpinner statusText="Loading Suppliers" />
                    }

                    { suppliers.status === 'success' && !activeSupplier && paymentTerms.status === 'success' && paymentMethods.status === 'success' && taxSettings.status === 'success' && suppliers.suppliers.length > 0 &&
                      <>
                        <h3>Suppliers</h3>

                        <div className="fieldset fieldset--select">
                          <div className="field field--medium">
                            <label className="field__label">Select Supplier</label>
                            <select className="field__select" onChange={(e) => activateSupplier(e.target.value)}>
                              <option hidden disabled selected={activeSupplier === null} value></option>
                              { suppliers.suppliers.map(supplier => 
                                <option selected={activeSupplier?.id === supplier.id} value={supplier.id} key={supplier.id}>{supplier.supplier_name}</option>
                              )}
                            </select>

                          </div>
                        </div>

                      </>
                    }

                    { suppliers.suppliers.length === 0 && !suppliers.isFetching &&
                      <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                        <div className="a-card__paddings text-center">
                          <p>No suppliers available. Add supplier information to see suppliers in a dropdown list here.</p>
                          <Link to="/suppliers">
                            <button
                              className="btn btn-default"
                            >
                              Manage Suppliers
                            </button>
                          </Link>
                        </div>
                      </div>
                    }

                    { activeSupplier && 
                      <div className="flex-container">
                        <div className="flex-1">
                          <h3>Supplier: { activeSupplier.supplier_name }</h3>
                          <h4>Address</h4>
                          <p>{activeSupplier.address.company ? `${activeSupplier.address.company} - ` : ''}{activeSupplier.address.first_name} {activeSupplier.address.last_name}
                          <br/>
                          {activeSupplier.address.street_1}
                          { activeSupplier.address.street_2 &&
                            <>
                              <br/>
                              {activeSupplier.address.street_2}
                            </>
                          }
                          <br/>
                          {activeSupplier.address.city}, {activeSupplier.address.state}
                          <br/>
                          {activeSupplier.address.zip}</p>
                        </div>
                        
                          <div className="flex-1 text-right left-15">
                            { locations.status === 'success' &&
                              <div className="flex-1">
                                <h4>Ship To Address</h4>

                                <div className="fieldset fieldset--select">
                                  <div className="field field--medium">
                                    <label className="field__label">Ship To Address</label>
                                    <select className="field__select" onChange={(e) => setShippingAddress(e.target.value)}>
                                      <option hidden disabled selected={activeShippingAddress === null} value></option>
                                      <option selected={activeShippingAddress?.id === 'Ecwid Origin'} value="Ecwid Origin" key="Ecwid Origin">Store Shipping Origin</option>

                                      { locations.locations.map(location => 
                                        <option selected={activeShippingAddress?.id === location.id} value={location.id} key={location.id}>{location.label}</option>
                                      )}
                                      { locations?.corporateLocations?.locations.map(location => 
                                        <option selected={activeShippingAddress?.id === location.id} value={location.id} key={location.id}>{location.label}</option>

                                      )}

                                    </select>

                                    <div className="field__placeholder">Ship To Address</div>
                                    <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                                    <span className="field-state--close"><svg xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 16 16"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0 c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73 c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                                    <span className="field__arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26"><path d="M7.85 10l5.02 4.9 5.27-4.9c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-6.45 6.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.66-.65 1.72-.65 2.37.01z"></path></svg></span>
                                  </div>
                                </div>

                              </div>
                            }
                            <br/>
                            { activeShippingAddress &&
                              <>
                                <h3>Ship To Address: { activeShippingAddress?.label }</h3>
                                <h4>Address</h4>
                                <p>{activeShippingAddress.company ? `${activeShippingAddress.company} - ` : ''}{activeShippingAddress.first_name} {activeShippingAddress.last_name}
                                <br/>
                                {activeShippingAddress.street_1 || activeShippingAddress?.address?.address1}
                                { (activeShippingAddress.street_2 || activeShippingAddress?.address?.address2) &&
                                  <>
                                    <br/>
                                    {activeShippingAddress.street_2 || activeShippingAddress?.address?.address2}
                                  </>
                                }
                                <br/>
                                {activeShippingAddress.city || activeShippingAddress?.address?.city}, {activeShippingAddress.state || activeShippingAddress?.address?.state}
                                <br/>
                                {activeShippingAddress.zip || activeShippingAddress?.address?.zip}</p>
                              </>
                            }
                          </div>
                      </div>
                    }

                  </div>
                </div>

                { activeSupplier &&
                  <div className="a-card a-card--normal">
                    <div className="a-card__paddings">

                      <h3>Purchase Order Information</h3>

                      { paymentTerms.status === 'success' &&
                        <div className="flex-1">
                          <h4>Payment Terms</h4>

                          <div className="fieldset fieldset--select fieldset__half-width">
                            <div className="field field--medium">
                              <label className="field__label">Payment Terms</label>
                              <select className="field__select" onChange={(e) => setPaymentTerm(e.target.value)}>
                                <option hidden disabled selected value></option>
                                { paymentTerms.paymentTerms.map(paymentTerm => 
                                  <option value={paymentTerm.id} key={paymentTerm.id}>{paymentTerm.term_name}</option>
                                )}

                              </select>

                              <div className="field__placeholder">{activePaymentTerm?.term_name || "Payment Terms"}</div>
                            </div>
                          </div>

                        </div>
                      }

                      { paymentMethods.status === 'success' &&
                        <div className="flex-1">
                          <h4>Payment Method</h4>

                          <div className="fieldset fieldset--select fieldset__half-width">
                            <div className="field field--medium">
                              <label className="field__label">Payment Method</label>
                              <select className="field__select" onChange={(e) => setPaymentMethod(e.target.value)}>
                                <option hidden disabled selected value></option>
                                { paymentMethods.paymentMethods.map(paymentMethod => 
                                  <option value={paymentMethod.id} key={paymentMethod.id}>{paymentMethod.method_name}</option>
                                )}

                              </select>

                              <div className="field__placeholder">{activePaymentMethod?.method_name || "Payment Method"}</div>
                            </div>
                          </div>

                        </div>
                      }

                      { taxSettings.status === 'success' &&
                        <div className="flex-1">
                          <h4>Tax Settings</h4>

                          <div className="fieldset fieldset--select fieldset__half-width">
                            <div className="field field--medium">
                              <label className="field__label">Tax Setting</label>
                              <select className="field__select" onChange={(e) => setTaxSetting(e.target.value)}>
                                <option hidden disabled selected value></option>
                                { taxSettings.taxSettings.map(taxSetting => 
                                  <option value={taxSetting.id} key={taxSetting.id}>{taxSetting.tax_name}</option>
                                )}

                              </select>

                              <div className="field__placeholder">{activeTaxSetting?.tax_name || "Tax Setting"}</div>
                            </div>
                          </div>

                        </div>
                      }

                      <hr/>

                      <div className="fieldset">
                        <div className="field field--medium">
                          <span className="fieldset__svg-icon"></span>
                          <label className="field__label">{`${settings.settings['invoice_number_override'] || "Invoice Number"}`}</label>
                          <input id="invoice_number" type="text" className="field__input" tabindex="4" maxlength="64" value={invoiceNumber} onChange={(e) => setFieldValue(setInvoiceNumber, e)} />
                          <div className="field__placeholder">{`${settings.settings['invoice_number_override'] || "Invoice Number"}`}</div>
                          <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                          <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                        </div>
                      </div>

                      <div className="fieldset left-15">
                        <div className="field field--medium">
                          <span className="fieldset__svg-icon"></span>
                          <label className="field__label">{`${settings.settings['purchase_order_number_override'] || "Purchase Order Number"}`}</label>
                          <input id="supplier_order_number" type="text" className="field__input" tabindex="4" maxlength="64" value={supplierOrderNumber} onChange={(e) => setFieldValue(setSupplierOrderNumber, e)} />
                          <div className="field__placeholder">{`${settings.settings['purchase_order_number_override'] || "Purchase Order Number"}`}</div>
                          <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                          <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                        </div>
                      </div>

                    </div>
                  </div>
                }


                </div>
            </div>
          </div>


          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Add Purchase Order Lines</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>

            <div className="named-area__body">

              <div className="a-card-stack">
      
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    { !activeSupplier &&
                      <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                        <div className="a-card__paddings">
                          <p>Select a supplier to begin adding purchase order lines.</p>
                        </div>
                      </div>
                    }

                    { activeSupplier &&
                      <>
                          <div className="graphic-radio-group">
                            <div className="graphic-radio-group__items">

                              <div className="graphic-radio graphic-radio--small">
                                <label className="graphic-radio__label">
                                  <input 
                                    type="radio"
                                    name="layout"
                                    value="on"
                                    className="graphic-radio__input"
                                    checked={activeTab === "list"}
                                    onChange={ () => setActiveTab('list') }
                                  />
                                  <div className="graphic-radio__icon">
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path d="M15 2H3v14h12ZM3 0a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" fill="currentColor" fill-rule="evenodd"/><path d="M5 5.5a1 1 0 0 1 1-1h6c1.33 0 1.33 2 0 2H6a1 1 0 0 1-1-1ZM6 8h6a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2ZM5 12.5a1 1 0 0 1 1-1h6c1.33 0 1.33 2 0 2H6a1 1 0 0 1-1-1z" fill="currentColor"/></svg>
                                    </span>
                                    <div className="graphic-radio__bg"></div>
                                  </div>
                                  <span className="graphic-radio__title">List Assignments</span>
                                </label>
                              </div>

                              <div className="graphic-radio graphic-radio--small">
                                <label className="graphic-radio__label">
                                  <input 
                                    type="radio"
                                    name="layout"
                                    value="on"
                                    className="graphic-radio__input"
                                    checked={activeTab === "search"}
                                    onChange={ () => setActiveTab('search') }
                                  />
                                  <div className="graphic-radio__icon">
                                    <span className="svg-icon">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill-rule="evenodd" clip-rule="evenodd" d="M18 7c0 3.866-3.134 7-7 7-1.5724 0-3.0236-.5184-4.1922-1.3936l-4.1007 4.1007c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3906-.3905-1.0237 0-1.4143l4.1007-4.1007C4.5184 10.0236 4 8.5723 4 7c0-3.866 3.134-7 7-7s7 3.134 7 7zm-2 0c0 2.7614-2.2386 5-5 5S6 9.7614 6 7s2.2386-5 5-5 5 2.2386 5 5z"/></svg>
                                    </span>
                                    <div className="graphic-radio__bg"></div>
                                  </div>
                                  <span className="graphic-radio__title">Search Products</span>
                                </label>
                              </div>

                              <div className="graphic-radio graphic-radio--small">
                                <label className="graphic-radio__label">
                                  <input 
                                    type="radio"
                                    name="layout"
                                    value="on"
                                    className="graphic-radio__input"
                                    checked={activeTab === "scan"}
                                    onChange={ () => setActiveTab('scan') }
                                  />
                                  <div className="graphic-radio__icon">
                                    <span className="svg-icon">
                                      <svg width="18" height="18" viewBox="0 0 32 32" id="svg5" version="1.1">
                                        <defs id="defs2"/>
                                        <g id="layer1" transform="translate(-108,-100)">
                                          <path d="m 111,106 a 1.0001,1.0001 0 0 0 -1,1 v 3 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -2 h 2 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z" id="path11698" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 134,106 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 2 v 2 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -3 a 1.0001,1.0001 0 0 0 -1,-1 z" id="path11700" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 137,121 a 1,1 0 0 0 -1,1 v 2 h -2 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 3 a 1.0001,1.0001 0 0 0 1,-1 v -3 a 1,1 0 0 0 -1,-1 z" id="path11702" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 111,121 a 1,1 0 0 0 -1,1 v 3 a 1.0001,1.0001 0 0 0 1,1 h 3 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -2 v -2 a 1,1 0 0 0 -1,-1 z" id="path11704" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 115,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11706" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 118,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11708" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 121,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11710" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 124,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11712" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 127,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11714" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 130,110 a 1,1 0 0 0 -1,1 v 10 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -10 a 1,1 0 0 0 -1,-1 z" id="path11716" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                          <path d="m 133,110 a 1,1 0 0 0 -1,1 v 5.20703 1.31445 V 121 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 V 117.52148 116.20703 111 a 1,1 0 0 0 -1,-1 z" id="path11720" style={{ 'fill-rule':'evenodd', 'stroke-linecap':'round', 'stroke-linejoin':'round', 'stroke-miterlimit':'4.1', '-inkscape-stroke':'none'}}/>
                                        </g>
                                      </svg>
                                    </span>
                                    <div className="graphic-radio__bg"></div>
                                  </div>
                                  <span className="graphic-radio__title">Scan Barcodes</span>
                                </label>
                              </div>

                            </div>
                          </div>


                        

                        <div className="a-card a-card--normal">
                          <div className="a-card__paddings">


                            { activeTab === 'list' &&
                              <AssignmentList
                                payload={payload}
                                activeSupplier={activeSupplier}
                                activeShippingAddress={activeShippingAddress}
                              />
                            }
                            { activeTab === 'search' &&
                              <ProductSearch
                                payload={payload}
                                activeSupplier={activeSupplier}
                                activeShippingAddress={activeShippingAddress}
                              />
                            }
                            { activeTab === 'scan' &&
                              <ProductScan
                                payload={payload}
                                activeSupplier={activeSupplier}
                              />
                            }

                          </div>
                        </div>

                      </>
                    
                    }
                  </div>
                </div>

              </div>
            </div>
          </div>


          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Purchase Order Lines Settings</div>
              </div>
              <div className="named-area__description">
                <p>
                  Add product/variant lines to this purchase order by selecting from a paginated set of products assigned to the selected supplier in the "List Supplier Assignments" tab, by searching your store in the "Search Products" tab, or by scanning barcodes in the "Scan Barcodes" tab.
                  If products are missing from this supplier, you can add them by going to the <Link to="/assignments">Supplier Assignments page</Link>.
                </p>
              </div>
            </div>

            <div className="named-area__body">

              <div className="a-card-stack">
      
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    { !activeSupplier &&
                      <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                        <div className="a-card__paddings">
                          <p>Select a supplier to begin adding purchase order lines.</p>
                        </div>
                      </div>
                    }

                    { activeSupplier &&
                      <div className="a-card a-card--normal">
                        <div className="a-card__paddings">
                          { purchaseOrderLines?.lineItems?.map(purchaseOrderLine => 
                            <PurchaseOrderLine
                              purchaseOrderLine={purchaseOrderLine}
                              purchaseOrderType={'restock'}
                              showSuggestionLevels={false}
                              showUpdateExternal={showUpdateExternal}
                            />

                          )}

                          <hr/>
                          <button
                            className="btn btn-default"
                            onClick={(e) => showAddExternal(e)}
                          >
                            <span className="svg-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 3h6.6716a3 3 0 0 1 2.1213.8787L19.4142 11.5 11.5 19.4142l-7.6213-7.6213A3 3 0 0 1 3 9.6716V3zm5.5 7c.8284 0 1.5-.6716 1.5-1.5S9.3284 7 8.5 7 7 7.6716 7 8.5 7.6716 10 8.5 10z"/></svg>
                            </span>
                            <span className="gwt-InlineLabel">Add external item</span>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>

              </div>
            </div>
          </div>
              



          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Totals, Adjustments and Dates</div>
              </div>
              <div className="named-area__description">
                <p>Add additional information and notes in the "Totals, Adjustments and Dates" panel, then create the purchase order by clicking the "Create Purchase Order" button.</p>
              </div>
            </div>

            <div className="named-area__body">

              <div className="a-card-stack">
      
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                  { !activeSupplier &&
                    <div className="a-card a-card--vertical-compact a-card--info a-card--info-blue">
                      <div className="a-card__paddings">
                        <p>Select a supplier to begin adding purchase order lines.</p>
                      </div>
                    </div>
                  }

                  { activeSupplier &&
                    <div>
                      <div className="flex-container">
                        <div className="flex-1">
                          <h4>Significant Dates</h4>

                          <div className="fieldset fieldset__half-width">
                            <div className="field field--medium field--filled">
                              <span className="fieldset__svg-icon"></span>
                              <label className="field__label">Invoice Date</label>
                              <input
                                type="date"
                                id="invoice_date"
                                value={invoiceDate}
                                min={todayForm()}
                                max={nextYear()}
                                onChange={(e) => setInvoiceDate(emptyToNull(e.target.value))} 
                                className="field__input"
                                onFocus={focus}
                                onBlur={blur}
                              />
                              <div className="field__placeholder">Invoice Date</div>
                              <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                              <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                            </div>
                            <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>

                            <br/>
                            <br/>

                            <div className="field field--medium field--filled">
                              <span className="fieldset__svg-icon"></span>
                              <label className="field__label">Expected Date</label>
                              <input
                                type="date"
                                id="expected_date"
                                value={expectedDate}
                                min={todayForm()}
                                max={nextYear()}
                                onChange={(e) => setExpectedDate(emptyToNull(e.target.value))} 
                                className="field__input"
                                onFocus={focus}
                                onBlur={blur}
                              />
                              <div className="field__placeholder">Expected Date</div>
                              <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                              <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                            </div>
                            <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
                            <br/><br/>


                            <div className="field field--medium field--filled">
                              <span className="fieldset__svg-icon"></span>
                              <label className="field__label">Payment Due Date</label>
                              <input
                                type="date"
                                id="payment_date"
                                value={paymentDate}
                                min={todayForm()}
                                max={nextYear()}
                                onChange={(e) => setPaymentDate(emptyToNull(e.target.value))} 
                                className="field__input"
                                onFocus={focus}
                                onBlur={blur}
                              />
                              <div className="field__placeholder">Payment Due Date</div>
                              <span className="field-state--success"><svg xmlns="http://www.w3.org/2000/svg" width="26px" height="26px" viewBox="0 0 26 26" focusable="false"><path d="M5 12l5.02 4.9L21.15 4c.65-.66 1.71-.66 2.36 0 .65.67.65 1.74 0 2.4l-12.3 14.1c-.33.33-.76.5-1.18.5-.43 0-.86-.17-1.18-.5l-6.21-6.1c-.65-.66-.65-1.74 0-2.41.65-.65 1.71-.65 2.36.01z"></path></svg></span>
                              <span className="field-state--close"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" enable-background="new 0 0 16 16" xml:space="preserve" focusable="false"><path d="M15.6,15.5c-0.53,0.53-1.38,0.53-1.91,0L8.05,9.87L2.31,15.6c-0.53,0.53-1.38,0.53-1.91,0c-0.53-0.53-0.53-1.38,0-1.9l5.65-5.64L0.4,2.4c-0.53-0.53-0.53-1.38,0-1.91c0.53-0.53,1.38-0.53,1.91,0l5.64,5.63l5.74-5.73c0.53-0.53,1.38-0.53,1.91,0c0.53,0.53,0.53,1.38,0,1.91L9.94,7.94l5.66,5.65C16.12,14.12,16.12,14.97,15.6,15.5z"></path></svg></span>
                            </div>
                            <div className="field__error" aria-hidden="true" style={{ display: 'none' }}></div>
                          </div>
                        </div>

                        <PurchaseOrderTotals
                          purchaseOrderLines={purchaseOrderLines}
                          activeSupplier={activeSupplier}
                          taxSetting={activeTaxSetting}
                          adjustedTotal={adjustedTotal}
                          shippingTotal={shippingTotal}
                          setAdjustedTotal={setAdjustedTotal}
                          setShippingTotal={setShippingTotal}
                        />
                      </div>
                    </div>
                  }
                  </div>
                </div>

              </div>
            </div>
          </div>
        

          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Finalize Purchase Order</div>
              </div>
              <div className="named-area__description">
                
              </div>
            </div>

            <div className="named-area__body">

              <div className="a-card-stack">
      
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">
                    { activeSupplier &&
                      <div className="fieldset fieldset--textarea">
                        <div className="field field--filled">
                          <textarea className="field__textarea" value={notes} tabindex="1" maxlength="200" onChange={(e) => setFieldValue(setNotes, e)}></textarea>
                          <div className="field__placeholder">Notes</div>
                        </div>
                      </div>
                    }

                    <button
                      className="btn btn-primary"
                      onClick={() => handleSubmit()}
                      disabled={validPO() || submitted}
                    >
                      <span className="svg-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9"><path d="M5 4V2.5a.5.5 0 1 0-1 0V4H2.5a.5.5 0 1 0 0 1H4v1.5a.5.5 0 1 0 1 0V5h1.5a.5.5 0 1 0 0-1H5z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1H1v7h7V1zM1 0C.4477 0 0 .4477 0 1v7c0 .5523.4477 1 1 1h7c.5523 0 1-.4477 1-1V1c0-.5523-.4477-1-1-1H1z"/></svg>
                      </span>
                      <span className="gwt-InlineLabel">Create Purchase Order</span>
                    </button>

                    { activeSupplier && !activeShippingAddress &&
                      <div className="text-small error">Purchase Order Must Specify a Shipping Address</div>
                    }
                    { activeSupplier && !activePaymentTerm &&
                      <div className="text-small error">Purchase Order Must Specify a Payment Term</div>
                    }
                    { activeSupplier && !activePaymentMethod &&
                      <div className="text-small error">Purchase Order Must Specify a Payment Method</div>
                    }
                    { activeSupplier && !activeTaxSetting &&
                      <div className="text-small error">Purchase Order Must Specify a Tax Setting</div>
                    }
                    { activeSupplier && !invoiceDate &&
                      <div className="text-small error">Purchase Order Must Include an Invoice Date</div>
                    }
                    { activeSupplier && !expectedDate &&
                      <div className="text-small error">Purchase Order Must Include an Expected Date</div>
                    }
                    { activeSupplier && !paymentDate &&
                      <div className="text-small error">Purchase Order Must Include an Expected Payment Date</div>
                    }
                    { activeSupplier && !(purchaseOrderLines?.lineItems.length > 0) &&
                      <div className="text-small error">Purchase Order Must Include Purchase Items</div>
                    }

                    { Object.keys(warnings.moq).map(warningId => 
                      <>
                        <div className="text-small warning">{warnings.moq[warningId]}</div>
                      </>
                      )
                    }

                    { Object.keys(warnings.orderMultiple).map(warningId => 
                      <>
                        <div className="text-small warning">{warnings.orderMultiple[warningId]}</div>
                      </>
                      )
                    }
                  </div>
                </div>

              </div>


            </div>
          </div>

        </div>
      </div>

      { showAddExternalItemModal &&
        <AddExternalItemModal
          payload={payload}
          showAddExternalItemModal={showAddExternalItemModal}
          setShowAddExternalItemModal={setShowAddExternalItemModal}
          modalY={modalY}
        />
      }

      { showUpdateExternalItemModal &&
        <UpdateExternalItemModal
          payload={payload}
          showUpdateExternalItemModal={showUpdateExternalItemModal}
          setShowUpdateExternalItemModal={setShowUpdateExternalItemModal}
          currentId={updateId}
          currentName={updateName}
          currentPrice={updatePrice}
          currentSku={updateSku}
          modalY={modalY}
        />
      }
    </>
  )
}

const mapStateToProps = state => ({
  shippingOrigin: state.accounts.store.store_details.shipping.shippingOrigin,
  suppliers: state.suppliers,
  purchaseOrders: state.purchaseOrders,
  newPurchaseOrder: state.purchaseOrders.newPurchaseOrder,
  taxSettings: state.taxSettings,
  paymentTerms: state.paymentTerms,
  locations: state.locations,
  paymentMethods: state.paymentMethods,
  purchaseOrderLines: state.purchaseOrderLines,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  loadTaxSettings: (payload) => dispatch(taxSettingsIndex(payload)),
  loadPaymentTerms: (payload) => dispatch(paymentTermsIndex(payload)),
  loadPaymentMethods: (payload) => dispatch(paymentMethodsIndex(payload)),
  loadSuppliers: (payload) => dispatch(suppliersIndex(payload)),
  loadLocations: (payload) => dispatch(locationsIndex(payload)),
  addPurchaseOrder: (payload, purchaseOrderJson, purchaseOrderLinesJson) => dispatch(purchaseOrdersCreate(payload, purchaseOrderJson, purchaseOrderLinesJson, 'restock')),
  clearPOLines: () => dispatch(reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewPurchaseOrderForm);